import { render } from "./CodeSnippet.vue?vue&type=template&id=144083fe"
import script from "./CodeSnippet.vue?vue&type=script&lang=js"
export * from "./CodeSnippet.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__